module.exports = __webpack_public_path__ + "img/icon-zalo.40157722.png";